import { Alert, Box, Stack, Typography } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

const FinishStep = ({ companySettings }) => (
  <Stack gap={2} alignItems="center" textAlign="center" py={2}>
    <CheckCircleRoundedIcon color="success" sx={{ fontSize: 64 }} />
    <Box>
      <Typography variant="h5" fontWeight={600}>
        {companySettings.orgName || 'Your organisation'} is ready to go 🎉
      </Typography>
      <Typography variant="body1" color="text.secondary" mt={1}>
        The essentials are in place. Next we'll take you to the Getting
        Started checklist, which walks you through inviting your team, adding
        vehicles and clients, and setting up your first event — at your own
        pace.
      </Typography>
    </Box>
    <Alert severity="info" sx={{ textAlign: 'left' }}>
      Everything you've set up here can be changed later under{' '}
      <b>Site Configuration</b>.
    </Alert>
  </Stack>
)

export default FinishStep
